import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { API_UCF, useNetwork } from '../network-context';
import { AppThunkDispatch } from '../../store/reducers/root-reducer';
import { ValuesToSendInterface } from '../../types/form.types';
import postFormService from '../services/post-form/post-form.service';
import postFormAction from '../../store/async-actions/post-form.action';

type usePostFormType =
  | ((data: ValuesToSendInterface, token: string) => Promise<void>)
  | undefined;
const usePostForm = (): usePostFormType => {
  const { getClient } = useNetwork();
  const dispatch = useDispatch<AppThunkDispatch>();

  const fetchFunction = useMemo(
    () =>
      getClient
        ? (
            data: ValuesToSendInterface,
            recaptchaToken: string
          ): Promise<void> => {
            return postFormService(getClient(API_UCF), data, recaptchaToken);
          }
        : undefined,
    [getClient]
  );

  return useMemo(
    () =>
      fetchFunction
        ? async (
            data: ValuesToSendInterface,
            recaptchaToken: string
          ): Promise<void> => {
            await dispatch(postFormAction(fetchFunction, data, recaptchaToken));
          }
        : undefined,
    [dispatch, fetchFunction]
  );
};

export default usePostForm;
